import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const PdfIcon: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="77"
    height="76"
    viewBox="0 0 77 76"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="pdf-icon-mask"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="77"
      height="76"
    >
      <rect width="77" height="76" rx="4" fill="#D9D9D9" />
    </mask>
    <g mask="url(#pdf-icon-mask)">
      <rect x="-10" y="-6" width="97" height="87" rx="6" fill="#FFE3E4" />
      <path
        d="M42.2532 18H27.2269C25.7801 18 24.6006 19.1795 24.6006 20.6341V55.6328C24.6006 57.0874 25.78 58.259 27.2347 58.2669H53.6154C55.0701 58.2669 56.2417 57.0874 56.2495 55.6328L56.1709 29.6374L42.2532 18Z"
        fill="#E5252A"
      />
      <path
        d="M42.2546 18L42.2153 29.3622C42.2153 29.3622 42.2546 29.6374 42.4905 29.6374H56.1723L42.2546 18Z"
        fill="#B71D21"
      />
      <path
        d="M22.0694 37.3982H48.6152C49.2049 37.3982 49.6846 37.8778 49.6846 38.4676V50.3251C49.6846 50.9149 49.2049 51.3945 48.6152 51.3945H22.0694C21.4796 51.3945 21 50.9149 21 50.3251V38.4676C21 37.8778 21.4796 37.3982 22.0694 37.3982Z"
        fill="#B71D21"
      />
      <path
        d="M42.0156 40.8906V48H40.3018V40.8906H42.0156ZM44.7793 43.8496V45.168H41.5273V43.8496H44.7793ZM45.0576 40.8906V42.2139H41.5273V40.8906H45.0576Z"
        fill="white"
      />
      <path
        d="M36.1367 48H34.5596L34.5693 46.6816H36.1367C36.4622 46.6816 36.7373 46.6035 36.9619 46.4473C37.1898 46.291 37.3623 46.0583 37.4795 45.749C37.5999 45.4365 37.6602 45.0524 37.6602 44.5967V44.2891C37.6602 43.9473 37.626 43.6478 37.5576 43.3906C37.4925 43.1302 37.3949 42.9137 37.2646 42.7412C37.1344 42.5654 36.9717 42.4336 36.7764 42.3457C36.5843 42.2578 36.363 42.2139 36.1123 42.2139H34.5303V40.8906H36.1123C36.5941 40.8906 37.0352 40.9736 37.4355 41.1396C37.8392 41.3024 38.1875 41.5368 38.4805 41.8428C38.7767 42.1455 39.0046 42.5052 39.1641 42.9219C39.3268 43.3353 39.4082 43.7943 39.4082 44.2988V44.5967C39.4082 45.098 39.3268 45.557 39.1641 45.9736C39.0046 46.3903 38.7783 46.75 38.4854 47.0527C38.1924 47.3555 37.8457 47.5898 37.4453 47.7559C37.0482 47.9186 36.612 48 36.1367 48ZM35.541 40.8906V48H33.8271V40.8906H35.541Z"
        fill="white"
      />
      <path
        d="M30.1504 45.5879H28.3828V44.2646H30.1504C30.3913 44.2646 30.5866 44.224 30.7363 44.1426C30.8861 44.0612 30.9951 43.9489 31.0635 43.8057C31.1351 43.6592 31.1709 43.4948 31.1709 43.3125C31.1709 43.1172 31.1351 42.9365 31.0635 42.7705C30.9951 42.6045 30.8861 42.471 30.7363 42.3701C30.5866 42.266 30.3913 42.2139 30.1504 42.2139H29.0273V48H27.3135V40.8906H30.1504C30.7201 40.8906 31.21 40.9948 31.6201 41.2031C32.0335 41.4115 32.3509 41.6979 32.5723 42.0625C32.7936 42.4238 32.9043 42.8372 32.9043 43.3027C32.9043 43.7617 32.7936 44.1621 32.5723 44.5039C32.3509 44.8457 32.0335 45.1126 31.6201 45.3047C31.21 45.4935 30.7201 45.5879 30.1504 45.5879Z"
        fill="white"
      />
    </g>
  </svg>
);
